<template>
    <div class="w100 mtop20">
        <b-row>
            <b-col cols="3" class="text-left">
                <!-- name -->
                <p>{{ $t("messages.login.name") }}</p>
            </b-col>
            <b-col cols="4" class="text-left">
                <!-- reel name -->
                 <el-input v-model="reel.name" size="mini" :placeholder=' $t("messages.reel")' maxlength="10"/>
            </b-col>
        </b-row>
        <b-row class="mtop10">
            <b-col cols="10" class="text-left">
                <b-button-group id="mode" class="menuOpt">
                    <b-button class="optInt" style="margin:0px;" @click="reel.info.manAutoTemp = 0" :pressed="reel.info.manAutoTemp  === 0">{{ $t("messages.manual") }}</b-button>
                    <b-button class="optInt" style="margin:0px;" @click="reel.info.manAutoTemp = 1" :pressed="reel.info.manAutoTemp  === 1">{{ $t("messages.auto") }}</b-button>
                    <b-button class="optInt" style="margin:0px;" @click="reel.info.manAutoTemp = 2" :pressed="reel.info.manAutoTemp  === 2">{{ $t("messages.tempo") }}</b-button>
                    <b-button v-if="poolId.main.hasLinked" class="optInt" style="margin:0px;" @click="reel.info.manAutoTemp = 3" :pressed="reel.info.manAutoTemp  === 3">{{ $t("messages.linked") }}</b-button>
                    <b-button v-if="poolId.main.hasLinkedAuto" class="optInt" style="margin:0px;" @click="reel.info.manAutoTemp = 4" :pressed="reel.info.manAutoTemp  === 4">{{ $t("messages.linked_auto") }}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <div v-if="reel.info.manAutoTemp===0" @click="reel.info.manAutoTemp = 0" class="w100">
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <!-- state -->
                    <p>{{ $t("messages.state") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <b-button-group id="mode" class="menuOpt">
                        <!-- OFF / ON -->
                        <b-button class="optInt" style="margin:0px;" @click="reel.info.onoff = 0" :pressed="reel.info.onoff  === 0">{{ $t("messages.off") }}</b-button>
                        <b-button class="optInt" style="margin:0px;" @click="reel.info.onoff = 1" :pressed="reel.info.onoff  === 1">{{ $t("messages.on") }}</b-button>
                        </b-button-group>
                </b-col>
            </b-row>
        </div>
    
        <div v-if="reel.info.manAutoTemp === 1"  @click="reel.info.manAutoTemp = 1" class="w100">
            <b-row class="mtop10"> 
                <b-col cols="3" class="text-left">
                    <!-- interval -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.interval") }} 1:</p>
                </b-col>
                       
                <b-col cols="3" class="text-left">
                    <el-time-picker v-model="timer1" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
                <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                    <p style="line-height:35px;margin-bottom:0;">-</p>
                </div>
                <b-col cols="3" class="text-left">
                    <el-time-picker  v-model="timer1To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
            </b-row>
         
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9">
                    <!-- select -->
                    <el-select v-model="reel.info.freq" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.interval") }} 2:</p>
                </b-col>
                <b-col cols="3" class="text-left">
                    <el-time-picker v-model="timer2" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
                <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                    <p style="line-height:35px;margin-bottom:0;">-</p>
                </div>
                <b-col cols="3" class="text-left">
                    <el-time-picker  v-model="timer2To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.freq2" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
        <div v-if="reel.info.manAutoTemp ===2" @click="reel.info.manAutoTemp = 2" class="w100">
             <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <!-- time minutes -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.time") }} ({{ $t("messages.minutes") }}):</p>
                </b-col>
                <b-col cols="9" class="text-left right">
                    <number-input v-model.number="reel.info.tiempoOn" :min="0" :max="180" inline center controls size="small"></number-input>
                </b-col>
             </b-row>
             <b-row>
                <b-col cols="3" class="text-left">
                    <!-- key -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.key") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left right">
                <el-select v-model="reel.info.key" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
        <div v-if="reel.info.manAutoTemp === 3"  @click="reel.info.manAutoTemp = 3" class="w100">
         
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.signal") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.signal">
                        <el-option v-for="item in getSignals" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.delay") }}:</p>
                    <p style="font-size: x-small;">({{ $t("messages.seconds") }})</p>
                </b-col>
                <b-col cols="9">
                    <number-input v-model="reel.info.delay " :step="1" :min="0" :max="30" inline center controls size="small"></number-input>
                </b-col>
            </b-row>
        
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.polarity") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.polarity">
                        <el-option v-for="item in getPolarity" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
        <div v-if="reel.info.manAutoTemp === 4"  @click="reel.info.manAutoTemp = 4" class="w100">
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.signal") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.signal">
                        <el-option v-for="item in getSignals" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.delay") }}:</p>
                    <p style="font-size: x-small;">({{ $t("messages.seconds") }})</p>
                </b-col>
                <b-col cols="9">
                    <number-input v-model="reel.info.delay " :step="1" :min="0" :max="30" inline center controls size="small"></number-input>
                </b-col>
            </b-row>
        
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.polarity") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.polarity">
                        <el-option v-for="item in getPolarity" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
            <b-row class="mtop10"> 
                <b-col cols="3" class="text-left">
                    <!-- interval -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.interval") }} 1:</p>
                </b-col>
                       
                <b-col cols="3" class="text-left">
                    <el-time-picker v-model="timer1" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
                <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                    <p style="line-height:35px;margin-bottom:0;">-</p>
                </div>
                <b-col cols="3" class="text-left">
                    <el-time-picker  v-model="timer1To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
            </b-row>
         
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9">
                    <!-- select -->
                    <el-select v-model="reel.info.freq" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.interval") }} 2:</p>
                </b-col>
                <b-col cols="3" class="text-left">
                    <el-time-picker v-model="timer2" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
                <div class="text-center" style="padding:0;width:10px !important;display:inline-block;">
                    <p style="line-height:35px;margin-bottom:0;">-</p>
                </div>
                <b-col cols="3" class="text-left">
                    <el-time-picker  v-model="timer2To" format="HH:mm" value-format="HH:mm" :clearable=false></el-time-picker>
                </b-col>
            </b-row>
            <b-row class="mtop10">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="reel.info.freq2" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
    </div>
</template>

<script>
import Actions from "./Actions";

export default {
    name: 'Relay',
    components:{
        Actions
    },
    props: {
        poolId: Object,
        reelNum: 0
    },
    data() {
        return {
            hasChanges: false,
            modbusReel: null,
            reel:{
                'info': {
                    'manAutoTemp': 0, 
                    'onoff': 0,
                    'freq': 0,
                    'freq2': 0, 
                    'from' : 0, 
                    'from2': 0,
                    'to': 0,
                    'to2': 0
                }
            },
             keys: [
                //  select key
                {
                     value: 0,
                     label: this.$t("messages.select")
                 },
                 {
                     value: 1,
                     label: this.$t("messages.key") +' (+)'
                 },
                {
                     value: 2,
                     label: this.$t("messages.key") +' (-)'
                 }
             ],
        }
    },
    created() {
        let fresh =  JSON.parse(JSON.stringify(this.poolId));
        this.original = JSON.parse(JSON.stringify(fresh));
        switch(this.reelNum){
            case 1:
                this.reel = fresh.relays.relay1
                this.modbusReel = 4
            break;
            case 2:
                this.reel = fresh.relays.relay2
                this.modbusReel = 5
            break;
            case 3:
                this.reel = fresh.relays.relay3
                this.modbusReel = 6
            break;
            case 4:
                this.reel = fresh.relays.relay4
                this.modbusReel = 7
            break;
        }

    },
    methods:{
        onSave() {
            let copy = JSON.parse(JSON.stringify(this.original));
            switch(this.reelNum){
                case 1:
                    copy.relays.relay1 = this.reel
                break;
                case 2:
                     copy.relays.relay2 = this.reel
                break;
                case 3:
                    copy.relays.relay3 = this.reel
                break;
                case 4:
                    copy.relays.relay4 = this.reel
                break;
            }
    
            this.$emit('onSave',this.original, copy, 'relays', this.reelNum);
            this.original = JSON.parse(JSON.stringify(copy));
            this.hasChanges = false
        },
        onCancel() {
            switch(this.reelNum){
                case 1:
                    this.reel = JSON.parse(JSON.stringify(this.original.relays.relay1));
                break;
                case 2:
                    this.reel = JSON.parse(JSON.stringify(this.original.relays.relay2));
                break;
                case 3:
                    this.reel = JSON.parse(JSON.stringify(this.original.relays.relay3));
                break;
                case 4:
                    this.reel = JSON.parse(JSON.stringify(this.original.relays.relay4));
                break;
            }
            this.hasChanges = false;
        },
    },
    watch: {
        'reel': {
            handler(value) {
                switch(this.reelNum){
                    case 1:
                        this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original.relays.relay1)) ? false : true
                    break;
                    case 2:
                        this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original.relays.relay2)) ? false : true
                    break;
                    case 3:
                        this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original.relays.relay3)) ? false : true
                    break;
                    case 4:
                        this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original.relays.relay4)) ? false : true
                    break;
                }
           
            },
            deep: true
        }
    },
    computed:{
        getPolarity(){
            return  [
                {
                    value: 0,
                    label: this.$t("messages.polarity_open")
                },
                {
                    value: 1,
                    label: this.$t("messages.polarity_closed")

                }
            ]
        },
        getSignals(){
            return  [
                {
                    value: 0,
                    label: this.$t("messages.cover")
                },
                {
                    value: 1,
                    label: 'FL1'
                },
                {
                    value: 2,
                    label: 'FL2'
                },
                {
                    value: 3,
                    label: this.$t("messages.slave")
                },
                {
                    value: 4,
                    label: 'Tank 1'
                },
                {
                    value: 5,
                    label: 'Tank 2'
                },
                {
                    value: 6,
                    label: 'Current loop 1'
                },
                {
                    value: 7,
                    label: 'Current loop 2'
                }
            ]
        },
        getFreqs(){
            return  [
                {
                    value: 86400,
                    label: this.$t("messages.daily")
                },
                {
                    value: 172800,
                    label: this.$t("messages.2daily")
                },
                {
                    value: 259200,
                    label: this.$t("messages.3daily")
                },
                {
                    value: 345600,
                    label: this.$t("messages.4daily")
                },
                {
                    value: 432000,
                    label: this.$t("messages.5daily")
                },
                {
                    value: 604800,
                    label: this.$t("messages.weekly")
                },
                {
                    value: 1209600,
                    label: this.$t("messages.2weekly")
                },
                {
                    value: 1814400,
                    label: this.$t("messages.3weekly")
                },
                {
                    value: 2419200,
                    label: this.$t("messages.4weekly")
                }
            ]
        },
        timer1:{
            get(){
                return this.$moment.unix(this.reel.info.from).utc().format("HH:mm") 
            },
            set(newDate) { 
                this.reel.info.from = this.$moment.duration(newDate).asSeconds()
            }
        },
        timer1To:{
            get(){
                return this.$moment.unix(this.reel.info.to).utc().format("HH:mm")
            },
            set(newDate) { 
                this.reel.info.to= this.$moment.duration(newDate).asSeconds()
            }
        },
        timer2:{
            get(){
                return  this.$moment.unix(this.reel.info.from2).utc().format("HH:mm")
            },
            set(newDate) { 
                this.reel.info.from2 = this.$moment.duration(newDate).asSeconds()
            }
        },
        timer2To:{
            get(){
                return this.$moment.unix(this.reel.info.to2).utc().format("HH:mm")
            },
            set(newDate) { 
                this.reel.info.to2= this.$moment.duration(newDate).asSeconds()
            }
        }
    },

    
}
</script>



// WEBPACK FOOTER //
// src/components/utils/Relay.vue